export const ENDPOINTS = Object.freeze({
	AUTH: {
		LOGIN: '/auth/login',
		REGISTER: '/auth/reg',
		SEND_EMAIL: '/auth/send-email',
		CONFIRM_EMAIL: '/auth/confirm-email',
		REQUEST_PASSWORD_RESET: '/auth/request-password-reset',
		CONFIRM_PASSWORD_RESET: '/auth/confirm-password-reset',
	},
	USER: {
		REFRESH: '/user/refresh_auth',
		INFO: '/user',
		CHANGE_PASSWORD: '/user/change-password',
		ORDERS: '/user/orders/list',
		UPDATE: '/user/update',
		UPDATE_ADDRESS: '/user/address'
	},
	PRODUCTS: {
		CATEGORIES: '/category',
		LIST: '/product',
		INFO: (id) => `/product/${id}`,
		DENOMINATIONS: (id) => `/product/${id}/denominations`,
	},
	ORDERS: {
		LIST: '/order/list',
		INFO: (id) => `/order/${id}`,
		CREATE: '/order/create',
		CREATE_TRANSACTION: '/transaction/init',
	},
	CART: {
		ADD: '/cart/add',
		UPDATE: '/cart/update',
		DELETE: '/cart/remove',
		INFO: '/cart',
	},
	MONTONIO: {
		PAYMENT_METHODS: '/montonio/payment-methods',
	}
});